import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Toasts } from "../../../Constant";
import LiveToast from "./LiveToast";
import ColorsSchemes from "./ColorsSchemes";
import StackingToasts from "./StackingToasts";
import TranslucentToasts from "./TranslucentToasts";
import DefaultToast from "./DefaultToast";
import UniqueToast from "./UniqueToast";
import ToastPlacement from "./ToastPlacement";

const ToastsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Toasts} parent={BonusUi} title={Toasts} />
      <Container fluid>
        <Row>
          <LiveToast />
          <ColorsSchemes/>
          <StackingToasts/>
          <TranslucentToasts/>
          <DefaultToast/>
          <UniqueToast/>
          <ToastPlacement/>
        </Row>
      </Container>
    </>
  );
};

export default ToastsContainer;
